export const environment = {
  isProduction: false,
  apiUrl: 'https://api-staging.grikocnavigasyon.com/v1',
  baseUrl: 'https://koc-staging.grikocnavigasyon.com',
  wsUrl: 'https://api-staging.grikocnavigasyon.com',
  authCookieName: 'coach_token',
  cdnBase: 'https://cdn.grikocnavigasyon.com',
  // Same player and proxy credentials as the student app: the coach previews the very
  // same streams from the very same proxy.
  flowPlayerToken: 'eyJraWQiOiJCWE9lQWtoZXdrUGkiLCJ0eXAiOiJKV1QiLCJhbGciOiJFUzI1NiJ9.eyJjIjoie1wiYWNsXCI6MzgsXCJpZFwiOlwiQlhPZUFraGV3a1BpXCJ9IiwiaXNzIjoiRmxvd3BsYXllciJ9.1w5uhdc4lrmTqeLbCP_HEJZbZw9eX5Gxqnk-B_9E29fb9hZ8FHntXblRcR7VU8iYjMJjwuXEo5E05pX-NA9TTg',
  videoProxyToken: 'ecec3a08-7d5b-2dce417e4679',
  logging: true,
};
